export const FALLBACK_PRICE = 99999;
